var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_2358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8258 8.18984L18.9643 0.0708008H17.2733L11.0724 7.11901L6.12337 0.0708008H0.413879L7.89936 10.73L0.413879 19.243H2.10487L8.649 11.7982L13.8766 19.243H19.5861M2.71519 1.31851H5.31303L17.272 18.0566H14.6736",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_2358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1722,
    height: 19.1722,
    fill: "white",
    transform: "translate(0.413879 0.0708008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoX);
export default __webpack_public_path__ + "static/media/logo-x.790b1036d7d774983df2c22ad5b1baa6.svg";
export { ForwardRef as ReactComponent };